<template>
  <section class="cities">
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal :label="$t('attributes.name')">
        <b-input v-model="group_name" disabled expanded></b-input>
      </b-field>

      <b-field horizontal :label="$t('attributes.group_code')">
        <b-input v-model="group_code" disabled expanded></b-input>
      </b-field>

      <b-field horizontal :label="$t('attributes.selected_cities')">
        <div class="content">
          <h3 class="has-text-info">
            {{ `最多只可選${this.maxCity}個城市` }}
          </h3>
        </div>
      </b-field>

      <b-field horizontal>
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-for="city in groupCities"
            v-model="form.cities"
            :key="city.city_code"
            :native-value="city"
            class="column is-2 is-marginless"
            @input="selected => onChangeCity(city, selected)"
          >
            {{ city.name }}
          </b-checkbox>
        </div>
      </b-field>

      <form-group
        horizontal
        name="country"
        :label="$t('message.select') + $t('attributes.country')"
      >
        <b-select
          v-model="selectedCountry"
          name="country"
          :placeholder="$t('message.please_select') + $t('attributes.country')"
          @input="onSelectCountry"
        >
          <option
            v-for="option in countries"
            :key="option.code"
            :value="option.code"
          >
            {{ option.english_name }}
            {{ option.name }}
          </option>
        </b-select>
      </form-group>

      <b-field horizontal :label="$t('attributes.add') + $t('attributes.city')">
        <div class="columns is-multiline is-mobile">
          <b-checkbox
            v-model="selectedCities"
            v-for="city in cities"
            :key="city.city_code"
            :native-value="city"
            class="column is-2 is-marginless"
            @input="selected => onSelectCity(city, selected)"
          >
            {{ city.name }}
          </b-checkbox>
        </div>
      </b-field>

      <b-field horizontal>
        <b-button
          disabled="disabled"
          :loading="sending"
          type="is-primary"
          native-type="submit"
          :style="{ width: '100%' }"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>

    <b-loading :active.sync="loading" :is-full-page="false"></b-loading>
  </section>
</template>

<script>
import { WEATHER_API, TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'WeathersForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      group_code: this.travelGroup.code,
      group_name: this.travelGroup.name,

      countries: [],
      cities: [],
      selectedCountry: null,
      selectedCities: [],

      maxCity: 10,
      groupCities: [],
      form: {
        cities: []
      }
    }
  },
  watch: {
    travelGroup(group) {
      this.group_code = group.code
      this.group_name = group.name
      this.selectedCountry = null
      this.loadGroupWeathers()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      await this.loadCountries()
      await this.loadGroupWeathers()
      this.loading = false
    },
    async loadGroupWeathers() {
      try {
        const api = `${TRAVEL_GROUPS_API}/${this.group_code}/weathers`
        const res = await this.axios.get(api)

        this.groupCities = [...res.data.data]
        this.form.cities = [...res.data.data]
      } catch (e) {
        this.groupCities = []
        this.form.cities = []

        notifyService.fetch_error('weather_list', e)
      }
    },
    async loadCountries() {
      try {
        const api = `${WEATHER_API}/countries`
        const res = await this.axios.get(api)

        this.countries = res.data.data
      } catch (e) {
        this.countries = []

        notifyService.fetch_error('weather_country_list', e)
      }
    },
    async loadCities() {
      try {
        this.loading = true
        const api = `${WEATHER_API}/countries/${this.selectedCountry}/cities`
        const res = await this.axios.get(api)

        this.cities = res.data.data
        this.selectedCities = this.cities.filter(
          c =>
            this.form.cities.findIndex(f => f.city_code === c.city_code) !== -1
        )
      } catch (e) {
        this.cities = []
        this.selectedCities = []

        notifyService.fetch_error('weather_country_list', e)
      } finally {
        this.loading = false
      }
    },
    onSelectCountry() {
      this.selectedCities = []
      this.loadCities()
    },
    onSelectCity(city, selectedCities) {
      let index = selectedCities.findIndex(c => c.city_code === city.city_code)
      const selected = index !== -1

      if (selected && this.form.cities.length >= this.maxCity) {
        notifyService.error(`最多只可選${this.maxCity}個城市`)

        const cities = [...selectedCities]
        cities.splice(index, 1)

        this.$nextTick(function() {
          this.selectedCities = [...cities]
        })
        return
      }

      index = this.groupCities.findIndex(c => c.city_code === city.city_code)
      if (index === -1) {
        this.groupCities = [...this.groupCities, city]
      }

      index = this.form.cities.findIndex(c => c.city_code === city.city_code)
      if (selected) {
        if (index === -1) {
          this.form.cities = [...this.form.cities, city]
        }
      } else {
        if (index !== -1) {
          this.form.cities.splice(index, 1)
        }
      }
    },
    onChangeCity(city, selectedCities) {
      let index = selectedCities.findIndex(c => c.city_code === city.city_code)
      const selected = index !== -1

      if (selected && this.form.cities.length > this.maxCity) {
        notifyService.error(`最多只可選${this.maxCity}個城市`)

        const cities = [...selectedCities]
        cities.splice(index, 1)

        this.$nextTick(function() {
          this.form.cities = [...cities]
        })

        return
      }

      index = this.cities.findIndex(c => c.city_code === city.city_code)

      if (index === -1) {
        return
      }

      index = this.selectedCities.findIndex(c => c.city_code === city.city_code)
      if (selected) {
        if (index === -1) {
          this.selectedCities = [...this.selectedCities, city]
        }
      } else {
        if (index !== -1) {
          this.selectedCities.splice(index, 1)
        }
      }
    },
    async onSend() {
      if (this.form.cities.length === 0) {
        notifyService.error('至少需選擇一個城市')
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.travelGroup.code}/weathers`
      const data = {
        cities: this.form.cities.map(c => c.city_code).join(',')
      }

      try {
        this.sending = true
        await this.axios.put(api, data)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
